import { render, staticRenderFns } from "./check-status-new.vue?vue&type=template&id=095352d4&scoped=true&"
import script from "./check-status-new.vue?vue&type=script&lang=js&"
export * from "./check-status-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095352d4",
  null
  
)

export default component.exports